"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lockedTableDataFragment = void 0;
exports.lockedTableDataFragment = `fragment TableDynamicFields on owner {
  dynamicFields(first: $limit, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      name {
        json
      }
      value {
        __typename
        ... on MoveValue {
          json
        }
      }
    }
  }
}
`;
//# sourceMappingURL=lockedTableDataFragment.js.map